export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'saveStatus',
    align: 'center',
    width: 100,
    title: '导入状态',
    slots: { default: 'status' },
  },
  {
    field: 'errorMsg',
    align: 'left',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    title: '客户名称(简称)',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'pointName',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    title: '门点名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'pointTypeName',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    title: '门点类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'tdpPointNo',
    headerAlign: 'center',
    align: 'center',
    width: 180,
    title: '三方门点编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  // {
  //   field: 'placeOfOrigin',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 150,
  //   title: '省市县',
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  //   sortable: false,
  //   sortType: 'string',
  // },
  {
    field: 'provinceName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    title: '省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'cityName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    title: '城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'districtName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 130,
    title: '区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'detailAddress',
    headerAlign: 'center',
    align: 'left',
    minWidth: 230,
    title: '详细地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    title: '联系人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'contactMobile',
    headerAlign: 'center',
    align: 'left',
    minWidth: 140,
    title: '联系人手机',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactEmail',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '联系人邮箱',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'weekDaySet',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '可用日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pointFence',
    align: 'center',
    width: 100,
    title: '电子围栏半径',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
